export var optionSkeleton = [];